import {
    CachingServiceCookiesKeys,
    CachingServiceCookiesKeysType,
    CachingServiceEntitiesType,
    CachingServiceLocalStorageKeys,
    CachingServiceLocalStorageKeysType,
} from "./type-declarations";
import {
    CachingService as BizkeytechCachingService,
    CachingServiceCookiesEntity,
    CachingServiceEntities,
    CachingServiceLocalStorageEntity
} from "../../../@bizkeytech";


/**
 * @inheritDoc
 */
class CachingService extends BizkeytechCachingService {

    /**
     * @inheritDoc
     */
    protected static LocalStorageEntity = new CachingServiceLocalStorageEntity<CachingServiceLocalStorageKeysType>({
        [CachingServiceLocalStorageKeys.dataGridSavedState]: "data-grid-saved-state",
        [CachingServiceLocalStorageKeys.cachedUrl]: "cached-url",
        [CachingServiceLocalStorageKeys.bizFileFileBaseUrl]: "biz-file-image-base-url",
        [CachingServiceCookiesKeys.bizFileFileToken]: 'biz-file-image-token',
        [CachingServiceLocalStorageKeys.partnerColorScheme]: "partner-color-scheme",
    });

    /**
     * @inheritDoc
     */
    protected static CookiesEntity = new CachingServiceCookiesEntity<CachingServiceCookiesKeysType>({
        [CachingServiceCookiesKeys.dataGridSavedState]: 'data-grid-saved-state',
        [CachingServiceLocalStorageKeys.cachedUrl]: "cached-url",
        [CachingServiceCookiesKeys.bizFileFileBaseUrl]: 'biz-file-image-base-url',
        [CachingServiceCookiesKeys.bizFileFileToken]: 'biz-file-image-token',
        [CachingServiceLocalStorageKeys.partnerColorScheme]: "partner-color-scheme",
    });

    /**
     * Fetches the cookies entity of this Caching service.
     * @param entityType
     */
    public static of(entityType: CachingServiceEntities.cookies): CachingServiceCookiesEntity<CachingServiceCookiesKeys>;
    /**
     * Fetches the local-storage entity of this Caching service.
     * @param entityType
     */
    public static of(entityType: CachingServiceEntities.localStorage): CachingServiceLocalStorageEntity<CachingServiceLocalStorageKeys>;
    /**
     * Fetches the requested entity of this Caching service based on the provided entityType.
     * @param entityType
     */
    public static of(entityType: CachingServiceEntities) {
        switch (entityType) {
            default:
                return super.of(entityType as any);
        }
    }

    /**
     * Fetches the value of the cached-url key.
     * @param instance  The instance to get the cached url from.
     */
    public static getCachedUrl(instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).get(CachingServiceLocalStorageKeys.cachedUrl);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).get(CachingServiceCookiesKeys.cachedUrl);
        }
    }

    /**
     * Sets the value of the cached-url key.
     * @param instance  The instance to set the cached url in.
     * @param value     The value to set.
     */
    public static setCachedUrl(value: any, instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).set(CachingServiceLocalStorageKeys.cachedUrl, value);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).set(CachingServiceCookiesKeys.cachedUrl, value);
        }
    }

    /**
     * Removes the cached-url key.
     * @param instance
     */
    public static removeCachedUrl(instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).remove(CachingServiceLocalStorageKeys.cachedUrl);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).remove(CachingServiceCookiesKeys.cachedUrl);
        }
    }

    /**
     * Fetches the value of the biz-file-file-base-url key.
     * @param instance  The instance to get the biz file image base url from.
     */
    public static getBizFileFileBaseUrl(instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).get(CachingServiceLocalStorageKeys.bizFileFileBaseUrl);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).get(CachingServiceCookiesKeys.bizFileFileBaseUrl);
        }
    }

    /**
     * Sets the value of the biz-file-file-base-url key.
     * @param instance  The instance to set the biz file image base url in.
     * @param value     The value to set.
     */
    public static setBizFileFileBaseUrl(value: any, instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).set(CachingServiceLocalStorageKeys.bizFileFileBaseUrl, value);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).set(CachingServiceCookiesKeys.bizFileFileBaseUrl, value);
        }
    }

    /**
     * Fetches the value of the biz-file-image-base-url key.
     * @param instance  The instance to get the biz file image base url from.
     */
    public static getBizFileFileToken(instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).get(CachingServiceLocalStorageKeys.bizFileFileToken);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).get(CachingServiceCookiesKeys.bizFileFileToken);
        }
    }

    /**
     * Sets the value of the biz-file-image-base-url key.
     * @param instance  The instance to set the biz file image base url in.
     * @param value     The value to set.
     */
    public static setBizFileFileToken(value: any, instance: CachingServiceEntitiesType = CachingServiceEntities.localStorage) {
        switch (instance) {
            case 'localStorage':
                return this.of(CachingServiceEntities.localStorage).set(CachingServiceLocalStorageKeys.bizFileFileToken, value);
            case 'cookies':
                return this.of(CachingServiceEntities.cookies).set(CachingServiceCookiesKeys.bizFileFileToken, value);
        }
    }
}

export * from "./type-declarations";
export {CachingServiceEntities} from "../../../@bizkeytech";
export default CachingService;
